<footer class="footer p-2">
    <ng-container *transloco="let t; prefix: 'footer'">
        <div class="row m-0 px-4 text-center">
            <div class="col-lg-5 text-lg-start align-self-center">
                <a class="mx-3 fs-6 fw-light text-decoration-none d-inline-flex" href="/cookie-and-privacy-policy">
                    {{t('link1') }}
                </a>
                <a class="mx-3 fs-6 fw-light text-decoration-none d-inline-flex" href="/ce-mark">
                    {{t('link2') }}
                </a>
                <a class="mx-3 fs-6 fw-light text-decoration-none d-inline-flex" href="/faq">
                    {{t('link3') }}
                </a>
                <a *ngIf="isPatient$ | async" class="mx-3 fs-6 fw-light text-decoration-none d-inline-flex"
                    (click)="navigateToUserPage('logs')" (keyup.enter)="navigateToUserPage('logs')" tabindex="0">
                    {{ t('link4') }}
                </a>
            </div>
            <div class="col-lg-2 align-self-center">
                <img class="justify-content-center" ngSrc="assets/images/NX-Logo_e-sundhed_RGB_cropped.png"
                     loading="eager" width="155" height="14" alt="NEXUS / E-SUNDHED" />
            </div>
            <div class="col-lg-5 text-lg-end align-self-center">
                <div class="hstack gap-3 justify-content-lg-end justify-content-center">
                    <div class="fw-light">{{ t('versionlabel') }}</div>
                    <div class="vr"></div>
                    <div class="fw-light">{{appVersion}}</div>
                </div>
            </div>
        </div>
        <hr />
        <div class="text-center">
            <p class="m-0 px-2 align-content-around copywrite-text">{{ t('trademarktext') }}</p>
        </div>
    </ng-container>
</footer>